import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { BindingCandidate } from '@core/models/installation.model';
import { TranslateModule } from '@ngx-translate/core';
import { channelLabel } from '../../channels';

// One channel a point could read, with what stands in the way of taking it.
@Component({
  selector: 'xemex-channel-candidate',
  imports: [TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './channel-candidate.component.html',
  styleUrl: './channel-candidate.component.scss',
})
export class ChannelCandidateComponent {
  readonly candidate = input.required<BindingCandidate>();
  // The channel the point reads now.
  readonly current = input(false);
  // The other points of this installation the channel also matches, by name.
  readonly sharedWith = input<string[]>([]);
  // A translation key: why the server refused this channel.
  readonly error = input<string | null>(null);

  protected readonly title = computed(() => channelLabel(this.candidate().source));
  // On a bound point its own channel is in use, held by the point itself.
  protected readonly heldElsewhere = computed(() => this.candidate().inUse && !this.current());
  protected readonly otherInstallationNames = computed(() =>
    (this.candidate().otherInstallations ?? []).map(other => other.name).join(', '),
  );
}
